import React, { useEffect, useState } from "react";
import { API } from "@/lib/api";

export const PinnedCreatives = ({ className = "" }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    fetch(`${API}/public/pinned-creatives`).then((r) => r.json()).then((d) => setItems(Array.isArray(d) ? d : [])).catch(() => {});
  }, []);
  if (!items.length) { return null; }
  return (
    <div className={`flex gap-3 overflow-x-auto ${className}`} data-testid="pinned-creatives">
      {items.map((c) => (
        <a key={c.id} href={`${API}/ai/images/${c.id}.png`} target="_blank" rel="noopener noreferrer" data-testid={`pinned-creative-${c.id}`}
          className="shrink-0 rounded-xl overflow-hidden ring-1 ring-gold/40 hover:ring-gold transition-shadow">
          <img src={`${API}/ai/images/${c.id}.png`} alt="Bengal Umrah House announcement" className="h-40 sm:h-48 w-auto object-cover" />
        </a>
      ))}
    </div>
  );
};
